import { useState, useCallback } from 'react';
import { useClientPreferences } from './useClientPreferences';
import type { Client } from '../../types/preferences';

export const useInitializeClientPreferences = () => {
  const { ensureClientExists, getClient } = useClientPreferences();
  
  const [isInitializing, setIsInitializing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [clientData, setClientData] = useState<Client | null>(null);

  const initializeClient = useCallback(
    async (
      enseigneCode: string,
      enseigneDisplayName: string,
      clientId: string,
      clientDisplayName: string
    ): Promise<Client | null> => {
      if (!enseigneCode || !clientId) return null;

      setIsInitializing(true);
      setError(null);

      try {
        let client = await getClient(enseigneCode, clientId);

        if (!client) {
          client = await ensureClientExists(
            enseigneCode,
            enseigneDisplayName,
            clientId,
            clientDisplayName,
            {
              language: 'fr',
              emailNotifications: true,
              smsNotifications: true,
              pushNotifications: false,
              marketingConsent: false,
            }
          );
        }

        setClientData(client);
        return client;
      } catch (err) {
        const errorMsg = err instanceof Error ? err.message : 'Erreur initialisation';
        setError(errorMsg);
        return null;
      } finally {
        setIsInitializing(false);
      }
    },
    [ensureClientExists, getClient]
  );

  return {
    initializeClient,
    isInitializing,
    error,
    clientData,
  };
};
